export const menuData = [
  {
    name: '用户中心',
    path: 'system',
    children: [
      {
        name: '首页',
        path: 'dirSupplier/home',
      },
    ],
    icon: 'setting',
  },
  {
    name: '定退货管理',
    path: 'order',
    children: [
      {
        name: '订货通知单',
        path: 'order/orderNotice',
      },
      {
        name: '验收单',
        path: 'order/orderAccept',
      },
      {
        name: '退货通知单',
        path: 'order/returnNotice',
      },
      {
        name: '退货单',
        path: 'order/returnFrom',
      },
    ],
    icon: 'setting',
  },
  {
    name: '账户设置',
    path: 'setting',
    children: [
      {
        name: '修改密码',
        path: 'setting/editpwd',
      },
      {
        name: '默认登录供应商',
        path: 'setting/defaultSelect',
      },
    ],
    icon: 'setting',
  },
];

function formatter(data, parentPath = '') {
  const list = [];
  data
    .sort((a, b) => a.menuSort - b.menuSort)
    .forEach((item, index) => {
      if (item.childs.length) {
        const obj = {
          id: item.id,
          name: item.menuName,
          path: `${parentPath}${item.menuUrl}`,
          children: formatter(item.childs, `${parentPath}${item.menuUrl}/`),
        };
        // 为了只给第一级菜单增加ICON
        if (item.menuLevel === 2) {
          obj.icon = item.menuPath;
        }
        list.push(obj);
      } else {
        list.push({
          name: item.menuName,
          path: `${parentPath}${item.menuUrl}`,
          id: item.id,
          icon: item.menuLevel === 2 ? item.menuPath : null,
        });
      }
    });
  return list;
}
export function formatDownload(data) {
  const list = {};
  data.map((o, i) => {
    list[o.key] = {
      desc: o.desc,
      downloadUrl: o.downloadUrl,
    };
  });
  return list;
}
export function formatHostList(data) {
  const list = [];
  data.map((o, i) => {
    list.push({
      value: o.warehouseCode,
      children: o.warehouseName,
    });
  });
  return list;
}
export const formatterData = formatter;
export const getMenuData = () => formatter(menuData);
